import { ComponentProps } from 'react';
import { useArrayFieldItemApi, useArrayFieldItemState } from 'informed';
import { TyInput } from '@tymbe/ui-forms';
import { Button } from '@tymbe/ui-primitives/*';
import { ActionIcon } from '@tymbe/ui-icons';
import PersonCard from './PersonCard';

const InvitationItem = ({ children, ...rest }: ComponentProps<any>) => {
  const arrayFieldItemApi = useArrayFieldItemApi();
  const arrayFieldState = useArrayFieldItemState();
  const invitation = arrayFieldItemApi.getValue('');

  return (
    <div className="flex gap-2 py-1.5 items-center" id={arrayFieldState.key}>
      <TyInput name="id" className="hidden" />
      <PersonCard personId={invitation?.id} className="grow" />

      <Button type="button" className="rounded-full bg-secondary-transparent-5 p-1 items-center" onClick={() => arrayFieldItemApi.remove()}><ActionIcon name="minimize" className="size-4" /></Button>
    </div>
  )
}

export default InvitationItem;
